import { Component, OnInit } from '@angular/core';
import { IAnnotation } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { ModalController } from '@ionic/angular';
import { AngularEditorConfig } from '@kolkov/angular-editor';


@Component({
  selector: 'inc-careplan-history-details',
  templateUrl: './careplan-history-details.component.html',
  styleUrls: ['./careplan-history-details.component.scss'],
})
export class CareplanHistoryDetailsComponent extends AbstractDetailsComponent<IAnnotation> implements OnInit {
  note: any;
  text = '';
  start = '';
  end = '';

  editorConfig: AngularEditorConfig = {
    editable: false,
    showToolbar: false,
  };

  constructor(private modalController: ModalController) {
    super();
  }

  ngOnInit() {
    if (this.inData) {
      this.note = this.inData.text.split('%');
      this.text = this.note[0];
      this.start = this.note[1] !== 'null' ? this.note[1] : '';
      this.end = this.note[2] !== 'null' ? this.note[2] : '';
    }
  }

  close() {
    this.modalController.dismiss();
  }
}
